import { render, staticRenderFns } from "./ServicePopup.vue?vue&type=template&id=165c4fdf&scoped=true&"
import script from "./ServicePopup.vue?vue&type=script&lang=js&"
export * from "./ServicePopup.vue?vue&type=script&lang=js&"
import style0 from "./ServicePopup.vue?vue&type=style&index=0&id=165c4fdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165c4fdf",
  null
  
)

export default component.exports